import { PropsWithChildren } from 'react';

import { SizeProp, StyledComponent, x } from '@ui-furniture/style';

import { ParentAnimation } from '../animation/parent';

export const Page: StyledComponent<
  PropsWithChildren<{
    maxW?: SizeProp;
    isFullScreen?: boolean;
  }>
> = ({ maxW = 'content-width', children }) => (
  <ParentAnimation>
    <x.div
      display='flex'
      w='100%'
      className='outer-page-container'
      alignItems='center'
      flexDirection='column'
    >
      <x.div
        w='100%'
        px={{
          _: 'md',
          tablet: 'lg',
        }}
        pt={{
          _: 'lg',
          tablet: '2xl',
        }}
        maxW={maxW}
        className='inner-page-container'
      >
        {children}
        <x.div
          opacity='0'
          mb={{
            _: 'lg',
            tablet: '2xl',
          }}
        />
      </x.div>
    </x.div>
  </ParentAnimation>
);
